<template>
  <div class="horizontal-screen" ref="horizontalScreen">
      <div class="content">
          <year-report :goToStatic="goToStatic" :isInApp="isInApp"  :getQuery="getQuery" :hidePageOne="hidePageOne" :showRotateTips='showRotateTips' ></year-report>
          <div class="plan-comm">
            <p class='pargh'>
                  <b class="report-blue">2,111,324</b> truckers have driven with us, contributing
                  <b class="report-blue">23,648,159</b> POI data updates for our community.
            </p>
          </div>
          <div class="line"></div>
          <div class="truck-stops">
              <div>
                <img src='@/assets/images/hor-screen/com1.png' />
                <img src='@/assets/images/hor-screen/com2.png' />
                <img src='@/assets/images/hor-screen/com3.png' />
              </div>
              <div>
                <p class='report-blue'>
                  <b class='small-font'>Top 3 Most Visited</b>
                  Truck Stop Brands 
                </p>
              </div>
          </div>
          <div class="line"></div>
          <div class="truck-ports">
              <div>
                <p class='report-blue'>
                  <b class='small-font'>3 States with Most</b>
                  Truck Parking Spots
                </p>
              </div>
              <div>
                <img src='@/assets/images/hor-screen/parking-spots1.png' />
                <img src='@/assets/images/hor-screen/parking-spots2.png' />
                <img src='@/assets/images/hor-screen/parking-spots3.png' />
              </div> 
          </div>
          <div class="line"></div>
          <div class="weight-stations">
            <div class="left-stations">
              <p class='report-blue'>
                <b class='small-font'>3 States with Most</b>
                <br/>Weigh Stations
              </p>
              <img src='@/assets/images/hor-screen/map.png' />
            </div>
            <div class="right-stations">
              <img src='@/assets/images/hor-screen/weigth-stations1.png' />
              <img src='@/assets/images/hor-screen/weigth-stations2.png' />
            </div>
          </div>
          <div class="line"></div>
          <div class="footer">
            <p>Thank you for driving with us in 2019 and wish you safe travels into the new year!</p>
          </div>
          <explore-tp :isInApp='isInApp' :querys='querys' :showRotateTips='showRotateTips'></explore-tp>
      </div>
  </div>
</template>
<script>
import yearReport from './yearReport.vue';
import exploreTp from './components/exploreTp.vue'
export default {
  name:'horizontal-screen',
  components:{
    exploreTp,
    yearReport
  },
  props:['isInApp','querys', 'goToStatic', 'getQuery','hidePageOne','showRotateTips'],
  data(){
    return {
    }
  }
}
</script>
<style lang="scss" scoped>

$rem: 66.7px;
html{
  font-size: $rem;
}
@function rem($px) {
  @return $px / $rem * 1rem;
}

$blue:rgb(3,118,239);
.report-blue{
  color: $blue;
}
.padding-common{
  padding:rem(35px) rem(49.5px);
  box-sizing: border-box;
}
.horizontal-screen{
  width:100%;
  background-color:rgba(229 ,241 ,252 ,0.35);
  // overflow-x:hidden;
  height: auto;
  .line{
    padding:0 rem(25px);
    &:before{
      content: '';
      display: block;
      border-bottom: 1px solid #0030621a;
    }
  }
  .content{
    max-width: rem(667px);
    margin: 0 auto;
    height: auto;
    background:rgba(229 ,241 ,252,0.35) ;
  }
    .plan-comm{
      display: flex;
      width:100%;
      padding-top:rem(20px) ;
      padding-bottom:rem(16.5px);
      padding-left:rem(25px);
      height: rem(233px);
      justify-content: flex-start;
      align-items: center;
      font-family: Gotham-Bold;
      background:rgba(229 ,241 ,252 ,0.35) url('../../assets/images/hor-screen/truck.png') no-repeat right top;
      background-size:rem(374.5px) rem(233px);
      .pargh{
          margin-top:rem(7.5px);
          line-height: rem(35px);
          font-size:rem(18px);
          color:#141A42;
          max-width: rem(325px);
        }

    }
    .puclic-commom-two{
      display: flex;
      justify-content: space-between;
      font-size:rem(27.5px);
      font-family: Gotham-Bold;
      > div{
        align-self: center;
      }
      .small-font{
        font-family: Gotham-Medium;
        font-size:rem(18px);
      }
    }
    .truck-stops{
      img{
        width:rem(108.5px);
        height:rem(123px);
        margin-right:rem(4px);
        &:last-child{
          margin-right:0;
        }
      }
      p{
        width:rem(182.5px);
      }
      @extend .puclic-commom-two;
      @extend .padding-common;
    }
    .truck-ports{
      img{
        width:rem(100px);
        height:rem(145px);
        margin-right:rem(12.5px);
        &:last-child{
          margin-right:0;
        }
      }
      p{
        width:rem(196px);
      }
      @extend .puclic-commom-two;
      @extend .padding-common;
    }
    .weight-stations{
      padding:rem(35px) rem(48px) rem(35px) 0;
      .left-stations{
        border-right:1px solid #0030621a;
        box-sizing: content-box;
        width:rem(395px);
        padding-right:rem(35px);
        p{
          padding-left:rem(49.5px);
          margin-bottom:rem(35px);
        }
        img{
          width:rem(395px);
          height:rem(326.5px);
        }
      }
      .right-stations{
        text-align: right;
        align-self: start;
        img{
          width:rem(157px);
          height:rem(159px);
          margin-bottom:rem(25px);
          &:last-child{
            margin-bottom:0;
          }
        }
      }
      @extend .puclic-commom-two;
    }
    .balloon{
      width:rem(24.5px);
      height:rem(43.5px);
    }
    .plane{
      width:rem(68.5px);
      height:rem(46px);
    }
    .footer{
      display:flex;
      height:rem(177px);
      align-items: center;
      padding-left:rem(25px);
      margin-top:rem(3.5px);
      margin-bottom:rem(2.5px);
      background: url('../../assets/images/hor-screen/truckBg.png') no-repeat top right;
      background-size:rem(373px) rem(177px);
      font-size:rem(13px);
      font-family: Gotham-Book;
      color:#141A42;
      line-height: rem(20px);
      p{
        width:rem(325px);
      }
    }
}
.explore-share{
  position: static;
  margin:0 rem(20px);
}

@media screen and (min-aspect-ratio: 414 / 414) and (max-aspect-ratio: 414 / 100){
    .scaleCanada{
      margin-top: 0;
    }
    .scaleUSA{
      margin-top: 0;
    }
  }
</style>